<template>
  <div class="c-app-menu-extra">
    <div v-if="isPortal" class="extra__wrapper">
      <div v-if="!isFolder" class="actions">
        <div class="action__item">
          <FavoriteAction :menu="menu" />
        </div>
        <div class="action__item">
          <MoreAction id="c-app-menu-more-action" :menu="menu" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { _, ref, nextTick,computed, reactive, provide, onMounted, useHostAppInstance } from '@zto/zpage'

import FavoriteAction from './extra/favorite-action.vue'
import MoreAction from './extra/more-action.vue'
import { introJsCheckStart, steps_home_menu } from '@zto/tuxi-operate-web-base'


const props = withDefaults(
  defineProps<{
    menu?: any
    isFolder?: boolean
  }>(),
  {}
)
const app = useHostAppInstance()

const isPortal = computed(() => {
  return app.isPortal
})
onMounted(async () => {
  if(app.isPortal){
    await nextTick(() => {
      setTimeout(()=>{
        const element = document.getElementById('c-app-menu-more-action');
        if(element && element.offsetHeight > 0){
          introJsCheckStart(steps_home_menu)
        }
      },1300)
    })
  }


})

</script>

<style lang="scss" scoped>
.c-app-menu-extra {
  position: relative;

  .extra__wrapper {
    position: absolute;
    z-index: 10;
    right: 0px;
    top: -5px;
  }
}

.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2px;

  .action {
    &__item {
    }
  }
}
</style>
